import { LoggingMessageInterface } from '../models';
import { LoggingChannelPubSubService } from '../services';
import { LogChannel } from '../constants';
import { inject } from '@angular/core';

export abstract class BaseLogging<InitProperties, LoggingPropertyConfiguration> {
  #loggingChannelPubSubService = inject(LoggingChannelPubSubService);

  abstract init(initProperties: InitProperties): void;
  abstract createSetup(loggingPropertyConfiguration: LoggingPropertyConfiguration): void;

  public sendToPubSub(logChannels: LogChannel[], message: LoggingMessageInterface) {
    this.#loggingChannelPubSubService.publish(logChannels, message);
  }
}
